import { AccordionButton, Box, Heading, HStack, Radio } from '@chakra-ui/react';
import { cx } from '@chakra-ui/utils';

type HeaderProps = {
  name: string;
  title: string;
  isExpanded: boolean;
  children: React.ReactElement;
};

export const AccordionHeader = ({
  name,
  title,
  isExpanded,
  children,
}: HeaderProps) => (
  <AccordionButton className={cx('TabButton')}>
    <>
      <Box as="div" flex="1" textAlign="left">
        <Radio
          value={name}
          isChecked={isExpanded}
          minW="200px"
          ml="2px"
          as="div"
        >
          <HStack as="div" gap={0}>
            <Box w="36px" mr="12px">
              {children}
            </Box>
            <Heading variant="h2">{title}</Heading>
          </HStack>
        </Radio>
      </Box>
    </>
  </AccordionButton>
);
